import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import * as actions from '../../actions';

class Popup extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.close = this.close.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentWillMount() {
    this.setState({ active: false, zIndex: false });
  }

  componentWillReceiveProps(props) {
    if (props.submitStatus) {
      this.setState({ active: true, zIndex: true });
    }
  }

  close() {
    this.setState({ active: false });
    const _this = this;

    setTimeout(function () {
      _this.props.dispatch(actions.setSubmitStatus(null));
      _this.setState({ zIndex: false });
    }, 350);
  }

  reset() {
    const { dispatch } = this.props;

    this.close();

    dispatch(actions.setUserName(null));
    dispatch(actions.setUserEmail(null));
    dispatch(actions.reset());
  }

  render() {
    const { submitStatus } = this.props;

    return (
      <div
        className={classNames({
          'material-box dark small-header left-buttons free-layout dialog': true,
          'active': this.state.active,
        })}
        style={{zIndex: this.state.zIndex ? 1060 : -1}}
      >
        <div className="material-box-content">
          <div className="top-bar">
            <header>
              {/*<h2>{submitStatus === 'error' ? 'Ошибка' : 'Отправлено'}</h2>*/}
            </header>
            <a
              className="btn btn-simple btn-close visible-box hidden-xs"
              onClick={this.close}
            >
              <span className="icon icon-material-close icon-remove" />
            </a>
          </div>
          <div className="content">
            <div className="row">
              <div className="col-xs-12 content-container">{/*
                submitStatus ===  'error' ?
                  'Произошла ошибка.' : 'Материалы успешно отправлены!'
              */}
              {/*<br /><br />*/}
              {
                submitStatus ===  'error' ?
                'Пожалуйста, попробуйте позднее.' : `Выбранные материалы
                 отправлены на указанный email. В случае если вы не получили
                  письмо, пожалуйста, проверьте папку «Спам».`
              }
              </div>
            </div>
            <div className="buttons">
              <a className="cmp-btn btn-primary" onClick={this.close}>
                <span className="btn-text t-base-text l-cta-text">ok</span>
              </a>
              {/*<a className="btn btn-action-secondary" onClick={this.reset}>очистить</a>*/}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Popup.propTypes = {
  submitStatus: PropTypes.string,
  dispatch: PropTypes.func,
};

export default connect(store => ({
  submitStatus: store.mainReducer.submitStatus,
}))(Popup);



// WEBPACK FOOTER //
// ./src/components/Form/Popup.js